import { DeptUser } from '@eastcoal/api/auth/interface'

import { isUserNode } from '../../utils/isUserNode'

import { MemberDeptUserCascaderOption } from './interface'

const hasLeafNode = (data?: MemberDeptUserCascaderOption[]): boolean => {
  if (!data?.length) {
    return false
  }
  return data.some(({ isLeaf, children }) => {
    if (isLeaf) return true
    return hasLeafNode(children)
  })
}
export const transformMemberDeptUserCascadeData = (
  data: DeptUser[]
): MemberDeptUserCascaderOption[] => {
  return data.map(({ id, name, type, children }) => {
    const isUser = isUserNode(type)
    const newChildren = children && transformMemberDeptUserCascadeData(children)
    const enable = isUser || hasLeafNode(newChildren)

    return {
      label: name,
      value: id,
      isLeaf: isUser,
      disabled: !enable,
      children: newChildren
    } as MemberDeptUserCascaderOption
  })
}
